export * from '@primeuix/themes/material/base';
export { default } from '@primeuix/themes/material/base';
